import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { bonoBotState, setCausesList } from 'store/bonoBot/bonoBot.slice';
import ChatInput from 'components/bonoBot/ChatInput';
import ChatMessages from 'components/bonoBot/ChatMessages';
import SocketInstanceContextProvider from 'context/socketInstanceContext';
import DonationPlan from 'components/bonoBot/DonationPlan';
import { storeImpactReports } from 'store/charities/charities.slice';
import { getImpactReportsByCharitiesIds } from 'store/charities/charities.services';
import { causesState } from 'store/causes/causes.slice';

const BonoBotChatPage = () => {
   const dispatch = useAppDispatch();
   const [selectedCharitiesIds, setSelectedCharitiesIds] = useState<number[]>([]);
   const { messages, causesList: botCausesList, charitiesList } = useAppSelector(bonoBotState);
   const { causesList } = useAppSelector(causesState);

   const prepareImpactReports = async (ids: number[]) => {
      const charitiesIds = ids.join(',');
      const response = await getImpactReportsByCharitiesIds({ charitiesIds });
      dispatch(storeImpactReports(response.data));
   };

   useEffect(() => {
      if (charitiesList.length > 0) {
         const currentIds = charitiesList.map((ch) => ch.id);
         const hasSameIds =
            currentIds.length === charitiesList.length && currentIds.every((id) => selectedCharitiesIds.includes(id));
         if (!hasSameIds) {
            setSelectedCharitiesIds(currentIds);
            prepareImpactReports(currentIds);
         }
      }
   }, [charitiesList]);

   useEffect(() => {
      if (botCausesList.length === 0 && causesList.length > 0) {
         dispatch(setCausesList(causesList));
      }
   }, [causesList]);

   return (
      <SocketInstanceContextProvider>
         <Box
            sx={{
               width: '100%',
               height: 'calc(100vh - 60px)',
            }}
         >
            {messages.length > 0 && <DonationPlan />}
            <Box
               sx={{
                  width: '100%',
                  height: messages.length > 0 ? 'calc(100vh - 172px)' : '100%',
                  display: 'flex',
               }}
            >
               <Box
                  sx={{
                     height: '100%',
                     width: '100%',
                     display: 'flex',
                     flexDirection: 'column',
                     alignItems: 'center',
                     justifyContent: 'center',
                     py: 2,
                  }}
               >
                  <ChatMessages />
                  <ChatInput />
               </Box>
            </Box>
         </Box>
      </SocketInstanceContextProvider>
   );
};

export default BonoBotChatPage;
